// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { User } from '@interfaces/user.interfaces';
import { tenantIsStellantis } from './../../utils/utils';

@Component({
    selector: 'welcome-to-ddj',
    templateUrl: './welcome-to-ddj.component.html',
    styleUrls: ['./welcome-to-ddj.component.scss'],
})
export class WelcomeToDDJComponent {
    public user: User = null;

    constructor(private readonly route: ActivatedRoute) {
        this.user = this.route.snapshot.data.user;
    }
}
